<template>
    <transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="opacity-0 translate-y-4"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-4"
    >
        <div
            v-if="items.length"
            class="fixed right-8 bottom-8 z-50 w-[360px] max-w-[calc(100vw-4rem)]
                bg-v-dark-950 text-white rounded-xl shadow-xl overflow-hidden"
        >
            <div
                class="flex items-center gap-3 px-4 py-3 border-b border-v-dark-800"
            >
                <v-icon
                    class="text-white flex-shrink-0"
                    size="4"
                    type="upload"
                    weight="bold"
                />
                <p class="flex-1 font-medium text-sm text-white leading-tight">
                    {{ headerTitle }}
                </p>
                <button
                    class="flex-shrink-0 size-7 rounded-md flex items-center justify-center
                        text-v-dark-400 hover:text-white hover:bg-v-dark-800 transition-colors"
                    type="button"
                    @click="$emit('dismiss')"
                >
                    <v-icon size="3.5" type="x" />
                </button>
            </div>
            <ul class="max-h-[320px] overflow-y-auto divide-y divide-v-dark-800">
                <li
                    v-for="item in items"
                    :key="item.id"
                    class="flex items-center gap-3 px-4 py-3"
                >
                    <v-icon
                        class="text-v-dark-400 flex-shrink-0"
                        size="4"
                        type="paper-clip"
                    />
                    <div class="flex-1 min-w-0">
                        <p class="font-medium text-sm text-white leading-5 truncate">
                            {{ item.name }}
                        </p>
                        <p
                            v-if="item.sizeLabel"
                            class="font-medium text-xs text-v-dark-400 leading-normal mt-0.5"
                        >
                            {{ item.sizeLabel }}
                        </p>
                    </div>
                    <v-icon
                        v-if="item.status === 'done'"
                        class="text-emerald-400 flex-shrink-0"
                        size="4"
                        type="check-circle"
                        weight="fill"
                    />
                    <v-icon
                        v-else-if="item.status === 'error'"
                        class="text-red-400 flex-shrink-0"
                        size="4"
                        type="x-circle"
                        weight="fill"
                    />
                    <v-icon
                        v-else
                        class="text-v-dark-300 flex-shrink-0"
                        size="4"
                        type="spinner"
                    />
                </li>
            </ul>
        </div>
    </transition>
</template>

<script>
    import VIcon from '@/components/elements/VIcon.vue';

    export default {
        name: 'v-upload-tray',
        components: { VIcon },
        props: {
            // Array of `{ id, name, sizeLabel, status: 'uploading'|'done'|'error' }`.
            items: { type: Array, required: true },
        },
        emits: ['dismiss'],
        computed: {
            headerTitle() {
                const total = this.items.length;
                if (!total) return '';
                const noun = total === 1 ? 'element' : 'elements';
                const inProgress = this.items.some(i => i.status === 'uploading');
                if (inProgress) return `Uploading ${total} ${noun}`;
                const errored = this.items.filter(i => i.status === 'error').length;
                if (errored) {
                    return `Uploaded ${total - errored} of ${total} (${errored} failed)`;
                }
                return `Uploaded ${total} ${noun}`;
            },
        },
    };
</script>
